import { createApp } from 'vue';
import ArticlesIndex from '../vue/Articles/ArticlesIndex.vue';

export default class Articles {
	constructor(elm) {
		this.elm = elm;
		this.vueComponent = createApp(ArticlesIndex, JSON.parse(this.elm.querySelector('script').textContent));
		this.vueComponent.mount(this.elm);
	}

	destroy() {
		this.vueComponent.unmount();
	}
}
